import { render, staticRenderFns } from "./ConnectedCredentialsDetails.vue?vue&type=template&id=2867a354&scoped=true"
import script from "./ConnectedCredentialsDetails.vue?vue&type=script&lang=js"
export * from "./ConnectedCredentialsDetails.vue?vue&type=script&lang=js"
import style0 from "./ConnectedCredentialsDetails.vue?vue&type=style&index=0&id=2867a354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867a354",
  null
  
)

export default component.exports